import { useContext } from 'react';

import { MeetingsScheduleContext } from './MeetingsScheduleProvider';

const useMeetingsScheduleContext = () => {
  const context = useContext(MeetingsScheduleContext);
  if (!context) throw new Error('useMeetingsScheduleContext must be used within a MeetingsScheduleProvider');
  return context;
};

export default useMeetingsScheduleContext;
